var render = function render(){var _vm=this,_c=_vm._self._c;return _c('markdown',{attrs:{"source":_vm.$t(_vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }